import React from "react";
import ProductsList from "../../components/ProductsList";

const Home = () => {
  return (
    <>
      <ProductsList />
    </>
  );
};

export default Home;
